import React from "react";
import { StyleSheet, Text, View } from "react-native";
import SectionList from "../../common/SectionList";
import type { SectionListItems } from "../../common/SectionList";
type Props = {
  onTypeSelection: (arg0: string) => void;
};
export default function HabitTypeSelection(props: Props) {
  const items: SectionListItems = [
    {
      key: "freeform",
      title: "Daily",
      onPress: () => props.onTypeSelection("freeform"),
      iconName: "star",
    },
    {
      key: "multi-day",
      title: "Multi Day",
      onPress: () => props.onTypeSelection("multi-day"),
      iconName: "calendar",
    },
    {
      key: "single-site",
      title: "Site",
      onPress: () => props.onTypeSelection("single-site"),
      iconName: "website",
    },
  ];
  return (
    <View style={styles.container}>
      <Text style={styles.labelTexts}>
        Select the type of habit you want to create:
      </Text>
      <SectionList items={items} />
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "stretch",
    alignSelf: "center",
    maxWidth: 600,
    width: "100%",
  },
});
